import {
  useState,
  useEffect,
  useRef
} from "react";
import { useMeeting } from "@videosdk.live/react-sdk";
import {
  App, Layout, Flex, Modal
} from "antd";
import { Participant } from "@videosdk.live/react-sdk/dist/types/participant";
import BottomBar from "../components/BottomBar";
// import Sidebar from "../components/Sidebar";
import MemorizedParticipantView from "./components/ParticipantView";
import WaitingToJoinScreen from "../components/screens/WaitingToJoinScreen";
import useVideoStore from "../hooks/useVideoStore";

const { Content, Footer } = Layout;

export function MeetingContainer() {
  const { message: appMessage } = App.useApp();

  // const { useRaisedHandParticipants } = useMeetingAppContext();
  const [
    localParticipantAllowedJoin,
    setLocalParticipantAllowedJoin
  ] = useState<boolean>(false);
  const [meetingErrorVisible, setMeetingErrorVisible] = useState(false);
  const [meetingError, setMeetingError] = useState<{ code: string, message: string } | null>(null);

  const mMeetingRef = useRef<any | null>(null);
  const [modal, contextHolder] = Modal.useModal();
  const { handleEndMeeting } = useVideoStore();

  // const { participantRaisedHand } = useRaisedHandParticipants();

  // const handleOnRecordingStateChanged = ({ status }: { status: string }) => {
  //   if (
  //     status === Constants.recordingEvents.RECORDING_STARTED
  //     || status === Constants.recordingEvents.RECORDING_STOPPED
  //   ) {
  //     notification.open({
  //       message: `${status === Constants.recordingEvents.RECORDING_STARTED
  //         ? "Meeting recording is started"
  //         : "Meeting recording is stopped."
  //       }`,
  //       duration: 4,
  //       placement: "bottomLeft"
  //     });
  //   }
  // };

  function onParticipantJoined(participant: Participant) {
    // Change quality to low, med or high based on resolution
    if (participant) participant.setQuality("high");
  }

  const onEntryResponded = (participantId: string, decision: string) => {
    if (mMeetingRef.current?.localParticipant?.id === participantId) {
      if (decision === "allowed") {
        setLocalParticipantAllowedJoin(true);
      } else {
        setLocalParticipantAllowedJoin(false);
      }
    }
  };

  const onMeetingLeft = () => {
    handleEndMeeting();
  };

  const handleOnError = (data: { code: string; message: string }) => {
    const { code, message } = data;
    appMessage.error(`meetingErr, ${code}, ${message}`);

    const joiningErrCodes = [
      "4001", "4002", "4003", "4004", "4005", "4006", "4007", "4008", "4009", "4010",
    ];

    const isJoiningError = joiningErrCodes.findIndex((c) => c === code) !== -1;
    const isCriticalError = `${code}`.startsWith("500");

    new Audio(
      isCriticalError
        ? "https://static.videosdk.live/prebuilt/notification_critical_err.mp3"
        : "https://static.videosdk.live/prebuilt/notification_err.mp3"
    ).play();

    setMeetingErrorVisible(true);
    setMeetingError({
      code,
      message: isJoiningError ? "Unable to join meeting!" : message,
    });
  };

  const mMeeting = useMeeting({
    onParticipantJoined,
    // @ts-ignore this is react-sdk issue, type definition if wrong
    onEntryResponded,
    onMeetingLeft,
    onError: handleOnError,
    // onRecordingStateChanged: handleOnRecordingStateChanged,
  });

  useEffect(() => {
    mMeetingRef.current = mMeeting;
  }, [mMeeting]);

  // usePubSub("RAISE_HAND", {
  //   onMessageReceived: (data) => {
  //     const localParticipantId = mMeeting?.localParticipant?.id;
  //
  //     const { senderId, senderName } = data;
  //
  //     const isLocal = senderId === localParticipantId;
  //
  //     new Audio(
  //       "https://static.videosdk.live/prebuilt/notification.mp3"
  //     ).play();
  //
  //     notification.open({
  //       message: `${isLocal ? "You" : nameTructed(senderName, 15)} raised hand 🖐🏼`,
  //       duration: 4,
  //       placement: "bottomLeft"
  //     });
  //
  //     participantRaisedHand(senderId);
  //   },
  // });

  // usePubSub("CHAT", {
  //   onMessageReceived: (data) => {
  //     const localParticipantId = mMeeting?.localParticipant?.id;
  //
  //     const { senderId, senderName, message } = data;
  //
  //     const isLocal = senderId === localParticipantId;
  //
  //     if (!isLocal) {
  //       new Audio(
  //         "https://static.videosdk.live/prebuilt/notification.mp3"
  //       ).play();
  //
  //       notification.open({
  //         message: `${trimSnackBarText(
  //           `${nameTructed(senderName, 15)} says: ${message}`
  //         )}`,
  //         duration: 4,
  //         placement: "bottomLeft"
  //       });
  //     }
  //   },
  // });

  useEffect(() => {
    if (meetingErrorVisible) {
      modal.info({
        title: `Error Code: ${meetingError?.code}`,
        content: meetingError?.message!,
        okText: "OKAY",
        onOk: () => { setMeetingErrorVisible(false); }
      });
    }
  }, [meetingErrorVisible]);

  return (
    <Layout style={{ background: "transparent" }}>
      <Layout style={{ height: "100vh", background: "transparent" }}>
        {localParticipantAllowedJoin ? (
          <>
            <Content>
              <Flex style={{ height: "100%", width: "100%", overflow: "hidden" }}>
                <MemorizedParticipantView isPresenting={false} />
              </Flex>
            </Content>
            <Footer style={{ background: "transparent" }}>
              <BottomBar />
            </Footer>
          </>
        ) : (
          // @ts-ignore @TODO: fix
          !mMeeting.isMeetingJoined && <WaitingToJoinScreen />
        )}
        {contextHolder}
      </Layout>
      {/* <Sidebar /> */}
    </Layout>
  );
}
